import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import useNavigationTab from "../../hooks/useNavigationTabs";
import { AddressPanelTabProps } from ".";
import Improvements from "./Improvements";
import {
  Section,
  TabContainer,
  Title,
  Wrapper,
} from "./__styles__/AddressPanel";
import { AuthContext } from "../Authorization/AuthContext";
import { map } from "lodash";
import TabGroup from "../Common/TabGroup";
import Logs from "./Logs";
import Submissions from "./Submissions";
import { RECORDS_TAB_NAME } from "common/routing";
import { FlexRow } from "../Common/__styles__/Layout";
import { OBJECT_TYPE, SUBMISSION_CATEGORY } from "common/constants";
import { getOptionalTabs } from "../../utils/submissions";

export const Layout = ({
  actionButton,
  children,
  title,
}: {
  actionButton?: React.ReactNode;
  children: React.ReactNode;
  title: string;
}) => (
  <div>
    <FlexRow style={{ justifyContent: "space-between" }}>
      <Title>
        <span>{title}</span>
      </Title>
      {actionButton}
    </FlexRow>
    {children}
  </div>
);

export const Records = (props: AddressPanelTabProps) => {
  const { account } = useContext(AuthContext);
  const { t } = useTranslation();

  const categories = new Set(
    account?.submissionTypes
      .filter(type =>
        type.attachments.some(
          attachment => attachment.type === OBJECT_TYPE.PROPERTY
        )
      )
      .map(type => type.category)
  );

  let tabs = [{ value: RECORDS_TAB_NAME.LOGS, label: "Logs" }];
  const optionalTabs = getOptionalTabs(t);

  tabs = tabs.concat(
    ...optionalTabs
      .filter(({ category }) => categories.has(category))
      .map(({ recordTabName, title }) => ({
        value: recordTabName,
        label: title,
      }))
  );

  const defaultTab = tabs[0]!;

  const [tab, setTab] = useNavigationTab({
    defaultTab: defaultTab.value,
    allowedTabs: map(tabs, "value"),
    queryParamName: "recordTab",
  });

  const currentOptionalTab = optionalTabs.find(
    ({ category, recordTabName }) =>
      category !==
        SUBMISSION_CATEGORY.SUBSTANTIAL_IMPROVEMENT_SUBSTANTIAL_DAMAGE &&
      tab === recordTabName
  );

  return (
    <>
      <TabContainer style={{ marginTop: "8px" }}>
        <TabGroup currentTab={tab} setTab={setTab} tabs={tabs} />
      </TabContainer>

      <Wrapper>
        <Section>
          {tab === RECORDS_TAB_NAME.IMPROVEMENTS && <Improvements {...props} />}
          {tab === RECORDS_TAB_NAME.LOGS && <Logs {...props} />}
          {currentOptionalTab && (
            <Submissions
              {...props}
              category={currentOptionalTab.category}
              title={currentOptionalTab.title}
              titleWithinCopy={currentOptionalTab.titleWithinCopy}
            />
          )}
        </Section>
      </Wrapper>
    </>
  );
};
